import { render, staticRenderFns } from "./sub-header.vue?vue&type=template&id=2e508b21&scoped=true&"
import script from "./sub-header.vue?vue&type=script&lang=js&"
export * from "./sub-header.vue?vue&type=script&lang=js&"
import style0 from "./sub-header.vue?vue&type=style&index=0&id=2e508b21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e508b21",
  null
  
)

export default component.exports